import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as assistanceListings from '../../../../assistance-listings'
import * as award from '../award'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: award.RESOURCE.payload.dimension.partialId,
      partialId: award.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'TODO',
    isOptional: true,
    name: 'Assistance Listing',
    partialId: PartialId.Standard.create('assistance_listing'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        assistanceListings.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
